import { render, staticRenderFns } from "./BidViewBidInfoCard.vue?vue&type=template&id=a80be1cc"
import script from "./BidViewBidInfoCard.vue?vue&type=script&lang=js"
export * from "./BidViewBidInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports